import React from 'react';

import { Flex, Label, get as themeGet } from '@betterment/style-closet-react';
import styled from '@emotion/styled';
import _without from 'lodash/without';

import { HandleCategoryUpdate, SetAccountRuleElgibileCategory, SetActiveModal } from './data';

import { DetailedTransaction } from '../../data';
import { CategoryIconMap, TransactionCategory } from '../TransactionIcon';

const Select = styled.select`
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3e%3cpath fillRule='evenodd' d='M12 16.4141L5.29289 9.70695L6.7071 8.29274L12 13.5856L17.2929 8.29274L18.7071 9.70696L12 16.4141Z' clipRule='evenodd'/%3e%3c/svg%3e");
  background-position: right;
  background-repeat: no-repeat;
  border: none;
  margin-bottom: 0;
  padding: 0;
  padding-right: calc(${themeGet('space.1')} + ${themeGet('space.8')});
  text-align-last: right;
  direction: rtl;
  @supports (text-align-last: right) {
    direction: ltr;
    text-align-last: right;
  }
`;

const CATEGORY_OPTIONS = Object.freeze(_without(Object.keys(CategoryIconMap), 'Debit Card Purchase'));

interface Props {
  transaction: DetailedTransaction;
  setActiveModal: SetActiveModal;
  setAccountRuleElgibileCategory: SetAccountRuleElgibileCategory;
  handleCategoryUpdate: HandleCategoryUpdate;
}

const CategoryDropdown: React.FC<React.PropsWithChildren<Props>> = ({
  transaction,
  setActiveModal,
  setAccountRuleElgibileCategory,
  handleCategoryUpdate,
}) => {
  const [pendingCategoryUpdate, setPendingCategoryUpdate] = React.useState<TransactionCategory | null>(null);
  const isEligibleForAccountRule = Boolean(transaction.merchant);

  const onChange: React.ChangeEventHandler<HTMLSelectElement> = async ({ target: { value } }) => {
    if (isEligibleForAccountRule) {
      setAccountRuleElgibileCategory(value as TransactionCategory);
      setActiveModal('category-update-confirmation');
    } else {
      setPendingCategoryUpdate(value as TransactionCategory);

      await handleCategoryUpdate({ category: value as TransactionCategory, shouldCreateRule: false });

      setPendingCategoryUpdate(null);
    }
  };

  const selectId = `transaction-${transaction.id}-category-select`;
  const labelId = `transaction-${transaction.id}-category-label`;

  return (
    <Flex px={[null, 6]} py="8">
      <Label id={labelId} htmlFor={selectId} mb="0">
        Category
      </Label>
      <Select
        id={selectId}
        aria-labelledby={labelId}
        value={pendingCategoryUpdate ?? CATEGORY_OPTIONS.find(c => c === transaction.category!) ?? 'Uncategorized'}
        onChange={onChange}
      >
        {CATEGORY_OPTIONS.map(category => (
          <option value={category} key={category}>
            {category}
          </option>
        ))}
      </Select>
    </Flex>
  );
};

export default CategoryDropdown;
